import axios from "axios";
import { firebaseFunctionsUrl } from "../Helpers/FirebaseEnvironments";

const extractJson = (content: string) => {
  try {
    if (content.trim().startsWith("{") || content.trim().startsWith("[")) {
      try {
        const jsonData = JSON.parse(content);
        return jsonData;
      } catch (error) {
        console.error("Error parsing JSON:", error, content);
        return null;
      }
    } else {
      console.error(
        "Invalid JSON format or content appears to be HTML:",
        content
      );
      return "Invalid JSON format or content appears to be HTML: " + content;
    }
  } catch (error) {
    console.error("Error parsing JSON:", error, content);
    return null;
  }
};

//   return `
//     <div>
//       <h2>Company Information</h2>
//       <p><strong>VAT:</strong> ${data.vat}</p>
//       <p><strong>Name:</strong> ${data.name}</p>
//       <p><strong>Address:</strong> ${data.address}</p>
//       <p><strong>Zip Code:</strong> ${data.zipcode}</p>
//       <p><strong>City:</strong> ${data.city}</p>
//       <p><strong>Phone:</strong> ${data.phone}</p>
//       <p><strong>Email:</strong> ${data.email}</p>
//       <p><strong>Start Date:</strong> ${data.startdate}</p>
//       <p><strong>Employees:</strong> ${data.employees}</p>
//       <p><strong>Industry Code:</strong> ${data.industrycode}</p>
//       <p><strong>Industry Description:</strong> ${data.industrydesc}</p>
//       <p><strong>Company Code:</strong> ${data.companycode}</p>
//       <p><strong>Company Description:</strong> ${data.companydesc}</p>
//       <h3>Owners</h3>
//       <ul>
//         ${data.owners.map((owner: any) => `<li>${owner.name}</li>`).join("")}
//       </ul>
//       <h3>Production Units</h3>
//       <ul>
//         ${data.productionunits
//           .map(
//             (unit: any) => `
//           <li>
//             <p><strong>Name:</strong> ${unit.name}</p>
//             <p><strong>Address:</strong> ${unit.address}</p>
//             <p><strong>Zip Code:</strong> ${unit.zipcode}</p>
//             <p><strong>City:</strong> ${unit.city}</p>
//             <p><strong>Start Date:</strong> ${unit.startdate}</p>
//             <p><strong>Employees:</strong> ${unit.employees}</p>
//             <p><strong>Industry Code:</strong> ${unit.industrycode}</p>
//             <p><strong>Industry Description:</strong> ${unit.industrydesc}</p>
//           </li>
//         `
//           )
//           .join("")}
//       </ul>
//     </div>
//   `;
// };

export const formatDetailedDARdata = (data: any) => {
  const generateHtml = (obj: any, indent = 0): string => {
    const indentation = "  ".repeat(indent);
    if (Array.isArray(obj)) {
      return `<ul>\n${obj
        .map((item) => `<li>${generateHtml(item, indent + 1)}</li>`)
        .join("\n")}\n${indentation}</ul>`;
    } else if (typeof obj === "object" && obj !== null) {
      return `<ul>\n${Object.entries(obj)
        .map(([key, value]) => {
          if (typeof value === "object" && value !== null) {
            return `<li><strong>${key}:</strong> ${generateHtml(value, indent + 1)}</li>`;
          } else {
            return `<li><strong>${key}:</strong> ${value ?? "N/A"}</li>`;
          }
        })
        .join("\n")}\n${indentation}</ul>`;
    } else {
      return `${indentation}${obj}`;
    }
  };

  return generateHtml(data);
};

const formatSummarizedCVRdata = (data: any) => {
  const generateHtml = (data: any[]) => {
    return `
      <div>
        <h2>Company List</h2>
        ${data
          .map(
            (item) => `
              <hr />
              <ul>
                <li><strong>CVR Number:</strong> ${item.CVRNummer}</li>
                <li><strong>Company Name:</strong> ${item.virksomhedsnavn.vaerdi}</li>
                <li><strong>Start Date:</strong> ${item.virksomhedStartdato}</li>
                <li><strong>Name Effective From:</strong> ${item.virksomhedsnavn.virkningFra}</li>
              </ul>
            `
          )
          .join("")}
      </div>
    `;
  };

  return generateHtml(data);
};

export const getDarById = async (criteria: string) => {
  try {
    if (criteria.trim()) {
      const registerUrl =
        "https://certservices.datafordeler.dk/DAR/DAR/3.0.0/rest/adresse?id=" +
        criteria;
      const res = await axios.get(firebaseFunctionsUrl("register"), {
        params: { apiUrl: registerUrl },
      });
      console.log("Response from DAR API:", res.data);
      const result = JSON.stringify(res.data);
      if (result) {
        console.info("Response from DAR API:", result); //
        const formattedResult = formatDetailedDARdata(JSON.parse(result));
        return formattedResult;
      } else {
        return "Web address not found.";
      }
    } else {
      return "Please enter a topic before generating output.";
    }
  } catch (error) {
    return "Get data failed: " + (error as Error).message;
  } finally {
  }
};

